import ContactForm from "@/components/ContactForm";
import { Seo } from "@/components/Seo";
import { Reveal, SectionTitle } from "@/components/primitives";

export default function Contact() {
  return (
    <div className="glow-black jmh-page jmh-contact-page">
      <Seo title="Contact Us" description="Contact Jennae Michelle Holdings — mailing address, phone, and email." />
      <h1 className="sr-only">Contact Jennae Michelle Holdings</h1>

      <section className="jmh-section jmh-page-opening">
        <div className="jmh-content-shell jmh-page-opening-grid">
          <figure className="jmh-opening-visual">
            <img width={1500} height={2000} decoding="async" src="/brand/contact-founder.jpg" alt="Jennae Michelle in the office before a world map" fetchPriority="high" />
          </figure>
          <div className="jmh-page-opening-copy">
          <Reveal><SectionTitle testid="contact-title">Some conversations need the right place to begin.</SectionTitle></Reveal>
          <Reveal delay={0.05}>
            <div className="jmh-contact-introduction text-[var(--bone)]/80">
              <p>Identify the relevant organization and describe the circumstances or question prompting your inquiry. This context enables us to assess its scope and, where appropriate, direct it to the team best positioned to review it.</p>
              <p className="text-[var(--bone)]/65 text-sm">Inquiries are handled discreetly and reviewed before any engagement is considered. Submission does not establish representation, create an advisory relationship, or guarantee that a matter will be accepted.</p>
            </div>
          </Reveal>

          <div className="jmh-contact-details">
            <Reveal>
              <p className="font-display uppercase tracking-luxe text-xs text-[var(--gold)]">Mailing Address</p>
              <p className="jmh-contact-address font-serif2 text-[var(--bone)]" data-testid="contact-address">
                Jennae Michelle Holdings, LLC<br />PO Box 29<br />Lebanon, PA 17042
              </p>
            </Reveal>
            <Reveal delay={0.06}>
              <div className="jmh-contact-links">
              <a href="tel:+17176606091" className="font-serif2 text-[var(--bone)] link-underline" data-testid="contact-phone">T: 717-660-6091</a>
              <a href="mailto:admin@jennaemichelle.com" className="font-serif2 gold-text link-underline" data-testid="contact-email">
                E: admin@jennaemichelle.com
              </a>
              </div>
            </Reveal>
          </div>
        </div>
        </div>
      </section>
      <ContactForm />
    </div>
  );
}
